<template>
  <div>
    <v-row>
      <v-col

        cols="12"
        lg="8"
        md="12"
      >
        <crisis-scenarios />
      </v-col>
      <v-col
        cols="12"
        lg="4"
        md="12"
      >
        <defence-readiness-outcome />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
      >
        <mild-crisis-assumptions />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import API from '@/api/Api'
import CrisisScenarios from '@/theme/default/views/banking/risk/liquidity/DefenceReadiness/CrisisScenarios.vue'
import CrisisScenarioEnum from '@/api/enums/CrisisScenarioEnum'
import DefenceReadinessOutcome from '@/theme/default/views/banking/risk/liquidity/DefenceReadiness/DefenceReadinessOutcome.vue'
import AssetModel from '@/api/models/asset/AssetModel'
import MildCrisisAssumptions from '@/theme/default/views/banking/risk/liquidity/DefenceReadiness/MildCrisisAssumptions.vue'

export default {
  name      : 'RiskDefenceReadiness',
  components: {
    CrisisScenarios,
    DefenceReadinessOutcome,
    MildCrisisAssumptions
  },
  mixins: [i18nRouteMeta],
  props : {
    selectedDate: {
      type   : String,
      default: ''
    }

  },
  dataStore: {
    appToolbarExtended          : 'App.Config.AppToolbarExtended',
    crisisScenario              : 'RiskLiquidity.CrisisScenario',
    depositBehavior             : 'RiskLiquidity.DepositBehavior',
    bankReadiness               : 'RiskLiquidity.BankReadiness',
    riskBaseCurrencyData        : 'Risks.BaseCurrency.Data',
    currentLiquidityParametersId: 'ActiveLiquidityParameters.currentLiquidityParametersId'
  },
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364,
      responseKeys  : [
        'crisisScenario',
        'depositBehavior',
        'bankReadiness'
      ],
      selectedCrisisScenario: CrisisScenarioEnum.Panic
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('ALM.HeaderTitle'),
        disabled: true
      }]
    },
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  watch: {
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }
  },
  created () {
    // Listen for crisis scenario changes to refresh data
    this.$bus.$on('RiskLiquidity:CrisisScenario:Changed', this.onCrisisScenarioChanged)
    this.$bus.$on('RiskLiquidity:DefenceReadiness:Rerun', this.rerunDefenceReadiness)

    this.findLatestDefenceReadiness()
    this.$bus.$on('liquidity:cancel-assumptions-edit', () => this.findLatestDefenceReadiness(CrisisScenarioEnum.Panic))
  },
  beforeDestroy () {
    this.$bus.$off('RiskLiquidity:CrisisScenario:Changed', this.onCrisisScenarioChanged)
    this.$bus.$off('RiskLiquidity:DefenceReadiness:Rerun', this.rerunDefenceReadiness)
    this.$bus.$off('liquidity:cancel-assumptions-edit', () => this.findLatestDefenceReadiness(CrisisScenarioEnum.Panic))
  },
  methods: {
    async findLatestDefenceReadiness (scenario = this.selectedCrisisScenario) {
      const response = await API.Resource.RiskLiquidity.FindLatestDefenceReadiness(this.accountId, scenario, this.currentLiquidityParametersId)
      this.handleResponse(response, 'findLatestDefenceReadiness')
    },

    async rerunDefenceReadiness (assumptions) {
      const response = await API.Resource.RiskLiquidity.RerunDefenceReadiness(this.accountId, assumptions, this.selectedCrisisScenario, this.currentLiquidityParametersId)

      // Handle the response directly from the rerun API call
      // The mutation response structure is different - it returns the data directly
      const data = API.responseData(response)?.rerunDefenceReadiness || null
      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        // Update the data store with the new results
        this.crisisScenario.Data = data
        this.depositBehavior.Data = data.depositBehavior
        this.bankReadiness.Data = data.bankReadiness
        this.$set(this.riskBaseCurrencyData, this.accountId, new AssetModel(data.baseCurrency ?? null))
      } else {
        this.$bus.$emit('app:error', errors)
      }

      // Deselect all crisis scenarios
      this.$bus.$emit('RiskLiquidity:CrisisScenario:DeselectAll')

      // Turn off edit mode
      this.$bus.$emit('RiskLiquidity:DefenceReadiness:SetEditMode', false)
    },

    onCrisisScenarioChanged (scenario) {
      this.selectedCrisisScenario = scenario
      if (scenario) {
        this.findLatestDefenceReadiness(scenario)
      }
    },

    handleResponse (response, key) {
      const data = API.responseData(response)?.[key] || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        for (const responseKey of this.responseKeys) {
          this[responseKey].Data = data[responseKey]
          if (data[responseKey].items) {
            this[responseKey].TotalItems = data[responseKey].items.length
            this[responseKey].CurrentPage = 1
          }
        }

        this.$set(this.riskBaseCurrencyData, this.accountId, new AssetModel(data.baseCurrency ?? null))
      } else {
        this.$bus.$emit('app:error', errors)
      }
    }
  }
}
    </script>

    <style scoped>
    </style>
